import { useState } from 'react';

export const useSelect = (items) => {
  const [selected, setSelected] = useState([]);
  const selectCard = (card) => {
    setSelected((prev) => {
      if (prev.includes(card.id)) return prev.filter((id) => id !== card.id);
      return prev.concat(card.id);
    });
  };

  const unselectCard = (id) => {
    setSelected((prev) => prev.filter((prevId) => id !== prevId));
  };

  const unselectAll = () => setSelected([]);

  const getSelectedCards = () =>
    items
      .filter((item) => selected.includes(item.id))
      .map((item) => ({
        title: item.fields.heading,
        image: item.fields.image,
        id: item.id,
      }));

  return [selected, selectCard, unselectCard, unselectAll, getSelectedCards];
};

export const cardsCompareFeatureTypes = {
  notExisting: 'n/a',
  boolean: 'boolean',
  html: 'html',
  plain: 'plain',
  currency: 'currency',
};

export const transformCardsFeatures = (cards) => {
  return cards.map((card) => {
    //receiving full and short features list from card
    const rawFull = card?.fields?.fullFeaturesList || [];
    const rawShort = card?.fields?.featuresList || [];
    const full = rawFull.map((feature) => transformFeature(feature));
    const short = rawShort.map((feature) => transformFeature(feature));
    return {
      ...card,
      fields: {
        ...card.fields,
        fullFeaturesList: full,
        featuresList: short,
      },
    };
  });
};

const transformFeature = (feature) => {
  const nameTitle = feature?.fields?.featureName?.fields?.DropdownText?.value;
  const nameValue = feature?.fields?.featureName?.fields?.DropdownValue?.value;
  const value = feature?.fields?.featureValue?.value;
  const isCurrency = feature?.fields?.isCurrency?.value;
  const valueType = getFeatureValueType(!!isCurrency, value);
  return { nameTitle, nameValue, value, valueType };
};

const getFeatureValueType = (isCurrency, value) => {
  if (isCurrency) return cardsCompareFeatureTypes.currency;
  const isHtml = new RegExp(/<[^>]*>?/gm);
  if (!value && value !== false) return cardsCompareFeatureTypes.notExisting;
  if (value === true || value === false) return cardsCompareFeatureTypes.boolean;
  if (isHtml.test(value)) return cardsCompareFeatureTypes.html;
  return cardsCompareFeatureTypes.plain;
};
